import { render, staticRenderFns } from "./OptionsMenuMobileComponent.vue?vue&type=template&id=ecd010c2&scoped=true"
import script from "./OptionsMenuMobileComponent.vue?vue&type=script&lang=js"
export * from "./OptionsMenuMobileComponent.vue?vue&type=script&lang=js"
import style0 from "./OptionsMenuMobileComponent.vue?vue&type=style&index=0&id=ecd010c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd010c2",
  null
  
)

export default component.exports